import { ProductExtendedTyShort } from '../../types'
import { OnChangeSearchBarAddProduct } from '../types'

interface SearchBarProductResultsProps {
    products: ProductExtendedTyShort[] | null
    onSelectProduct: OnChangeSearchBarAddProduct
    className?: string
}

const SearchBarProductResults: React.FC<SearchBarProductResultsProps> = ({ products, onSelectProduct, className }) => {
    const renderThis: JSX.Element[] = []
    if (!products) {
        return null
    }
    for (const key in products) {
        const product = products[key]
        renderThis.push(<SearchedProduct key={key} product={product} onSelectProduct={onSelectProduct} />)
    }
    return (
        <div className={'searched_input_products ' + (className || '')}>
            <div className='results_searched_products'>
                {renderThis}
            </div>
        </div>
    )
}

interface SearchedProductProps {
    onSelectProduct: OnChangeSearchBarAddProduct
    product: ProductExtendedTyShort
}

const SearchedProduct: React.FC<SearchedProductProps> = ({ product, onSelectProduct }) => {
    const productName = product['ProductLangs.name'] || product?.ProductLangs?.[0].name || product.name
    const reference = product.reference
    const unique_number = product.unique_number
    let productImg = product['ProductImages.url'] || product.url || product['imageParentUrl'] || undefined
    if (productImg === undefined) {
        if (product?.ProductImages?.length) {
            productImg = product?.ProductImages?.[0].url
        }
    }
    return (
        <div className='searched_product ' onClick={() => onSelectProduct(product)} title={(reference || unique_number) + ' - ' + productName}>
            <img src={productImg || '/no-image-small.png'} alt={productName} className='related_product_img' />
            <div className='twin_elipsis'>
                <span className='text-green-00 font-medium'>{reference || unique_number}</span>
                <span className='mx-5 text-green-00'>-</span>
                <span className=''>{productName}</span>
            </div>
        </div>
    )
}
export const SearchBarProductResultsWithCodeBar: React.FC<SearchBarProductResultsProps> = ({ products, onSelectProduct, className }) => {
    const renderThis: JSX.Element[] = []
    if (!products) {
        return null
    }
    for (const key in products) {
        const product = products[key]
        renderThis.push(<SearchedProductWithCodeBars key={key} product={product} onSelectProduct={onSelectProduct} />)
    }
    return (
        <div className={'searched_input_products ' + (className || '')}>
            <div className='results_searched_products'>
                {renderThis}
            </div>
        </div>
    )
}

const SearchedProductWithCodeBars: React.FC<SearchedProductProps> = ({ product, onSelectProduct }) => {
    const productName = product['ProductLangs.name'] || product?.ProductLangs?.[0].name || product.name
    const reference = product.reference
    const codeBar = product.code_bar
    let productImg = product['ProductImages.url'] || product.url ||  undefined
    if (productImg === undefined) {
        if (product?.ProductImages?.length) {
            productImg = product?.ProductImages?.[0].url
        }
    }
    return (
        <div className='searched_product ' onClick={() => onSelectProduct(product)} title={reference + ' - ' + productName + (codeBar ? (' - ' + codeBar) : '')}>
            <img src={productImg || '/no-image-small.png'} alt={productName} className='related_product_img' />
            <div className='twin_elipsis'>
                <span className='text-green-00 font-medium'>{reference}</span>
                <span className='mx-5 text-green-00'>-</span>
                <span className=''>{productName}</span>
                {codeBar ? <span className='text-gray-8F twin_elipsis'> <span className='mx-5'>-</span>{codeBar}</span> : null}
            </div>
        </div>
    )
}

export const SearchBarProductResultUniqueNumber: React.FC<SearchBarProductResultsProps> = ({ products, onSelectProduct, className }) => {
    const renderThis: JSX.Element[] = []
    if (!products) {
        return null
    }
    for (const key in products) {
        const product = products[key]
        renderThis.push(<SearchedProductUniqueNumber key={key} product={product} onSelectProduct={onSelectProduct} />)
    }
    return (
        <div className={'unique_number searched_input_products ' + (className || '')}>
            <div className='results_searched_products'>
                {renderThis}
            </div>
        </div>
    )
}

const SearchedProductUniqueNumber: React.FC<SearchedProductProps> = ({ product, onSelectProduct}) => {
    const uniqueNumber = product.unique_number
    const productName = product['ProductLangs.name'] || product?.ProductLangs?.[0].name || product.name
    return (
        <div className='searched_product twin_elipsis ' onClick={() => onSelectProduct(product)} title={uniqueNumber}>
            <div className='twin_elipsis'>
                <span className='text-green-00 font-medium'>{uniqueNumber}</span>
                <span className='mx-5 text-green-00'>-</span>
                <span className=''>{productName}</span>
            </div>
        </div>
    )
}

export default SearchBarProductResults